/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

/**
 * @class wc-api-person
 */
import {registerNewUser} from './registerNewUser.js';
import {getUserData} from './getUserData.js';
import {isRegisteredUser} from './isRegisteredUser.js';
import {getUserIdentity} from './getUserIdentity.js';
import {getUserSession} from './getUserSession.js'; // facade version
import {getGuestToken} from './getGuestToken.js';
import {migrateGuestToRegisteredUser} from './migrateGuestToRegisteredUser.js';
import getAddressBook from './getAddressBook.js';
import registerNewAddressBook from './registerNewAddressBook';
import editAddressBook from './editAddressBook';
import removeAddressBook from './removeAddressBook';
import getWallet from './getWallet';
import {loginByUserName} from './loginByUserName';
import logoffUser from './logoffUser';
import removeCommerceCookies from './removeCommerceCookies'
import getBillingAddress from './getBillingAddress';
import validateShopRunner from './validateShopRunner';
import { createAccountSignUp } from './createAccountSignUp';
import tokenizeCard from './tokenizeCard';
import addCardToWallet from './addCardToWallet';

const PersonClient = {
     registerNewUser, getUserData, isRegisteredUser, getUserIdentity, getUserSession,
     getGuestToken, migrateGuestToRegisteredUser, 
     getAddressBook, registerNewAddressBook, editAddressBook, removeAddressBook, getBillingAddress, getWallet, 
     loginByUserName, logoffUser, removeCommerceCookies, validateShopRunner, createAccountSignUp, tokenizeCard,
     addCardToWallet,
};

export default PersonClient; 